module.exports = __webpack_public_path__ + "img/21-days-promo-welcome-header.f67c0146.png";